import axios from 'axios';

const downloadCsv = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'elegiveis-atual');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const tryExportingElegibles = (promoId, setLoading, setErrorExport) => {
    setLoading(true);
    axios
        .get(`${process.env.REACT_APP_API_URL}/admin/elegiveis/export?promo_id=${promoId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('adminAccessToken')}`
            },
        })
        .then((response) => {
            downloadCsv(response.data.url);
            setLoading(false);
        })
        .catch((err) => {
            setLoading(false);
            setErrorExport(err.response.data.message)
        });
}

export default tryExportingElegibles;